export const SIGN_IN_REQUEST = 'SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';
export const SIGN_OUT = 'SIGN_OUT';

export const signInRequest = (data) => ({
  type: SIGN_IN_REQUEST,
  payload: data,
});

export const signInSuccess = (data) => ({
  type: SIGN_IN_SUCCESS,
  payload: data,
});

export const signInFailure = (error) => ({
  type: SIGN_IN_FAILURE,
  payload: error,
});

export const signOut = (data) => ({
  type: SIGN_OUT,
  payload: data,
});